import React from "react";
import { useTranslation } from "react-i18next";

/**
 * The QR section: where to put the code, and the three beats a guest goes
 * through once they scan it.
 *
 * The flow is rendered typographically rather than with a QR illustration —
 * there is no couple-facing QR artwork in `public/assets`, and the product does
 * not offer branded or printable QR cards, so inventing a mock-up here would
 * illustrate a capability that does not exist. See the handover note about the
 * one image this page would benefit from.
 *
 * `Scan → Join → Share` is a real ordered sequence (each step depends on the
 * one before it), which is why it is an <ol> and why the arrows are decorative
 * (`aria-hidden`) rather than content.
 */
const FLOW_KEYS = ["scan", "join", "share"];

const PhotoSharingQr = () => {
  const { t } = useTranslation();

  return (
    <section className="section topless wps-section">
      <div className="container">
        <div className="wps-editorial wps-editorial-solo">
          <div className="wps-editorial-text">
            <h2 className="heading-50">{t("weddingPhotoSharing.qr.heading")}</h2>
            <p className="body-20">{t("weddingPhotoSharing.qr.body")}</p>
          </div>
        </div>

        <div className="wps-flow" aria-labelledby="wps-flow-label">
          <p id="wps-flow-label" className="wps-eyebrow wps-flow-label">
            {t("weddingPhotoSharing.qr.flowLabel")}
          </p>
          <ol className="wps-flow-list">
            {FLOW_KEYS.map((key, index) => (
              <li key={key} className="wps-flow-step">
                <span className="wps-flow-step-txt">
                  {t(`weddingPhotoSharing.qr.flow.${key}`)}
                </span>
                {index < FLOW_KEYS.length - 1 ? (
                  <span className="wps-flow-arrow" aria-hidden="true">
                    →
                  </span>
                ) : null}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default PhotoSharingQr;
